import { styled } from 'styled-components';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;

    .title {
        font-weight: 700;
        font-size: 12px;
        line-height: 120%;
        color: ${({ theme }) => theme.color.dark};
        margin-bottom: 8px;
    }

    .address {
        cursor: pointer;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 130%;
        color: ${({ theme }) => theme.color.primary};
        margin-bottom: 8px;
    }

    .worktime {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 130%;
        text-transform: uppercase;
        color: ${({ theme }) => theme.color.dark};
    }
`;
